// src/Components/ErrorPages/Error404.jsx
import { useNavigate } from 'react-router-dom';
import './ErrorPages.css';

const Error404 = () => {
  const navigate = useNavigate();
  return (
    <div className="errorContainer">
      <span className="errorCodigo">404</span>
      <h2 className="errorTitulo">Página no encontrada</h2>
      <p className="errorMensaje">
        La URL que buscás no existe o fue movida.
      </p>
      <button onClick={() => navigate('/')} className="errorBtn">
        Volver al inicio
      </button>
    </div>
  );
};

export default Error404;
